import { loadStripe } from "@stripe/stripe-js";

export const stripePromise = loadStripe(
  // "pk_test_51KWJXvG2idM3kMKk3of5pbtc0Zyq2h5bezAaQtLnCXYm0lAHNzhK3hvB5cPs2oAmO3XuXAoAXAuLTLoC3CbjaiUz00YPpSCJWy"
  "pk_live_51KWJXvG2idM3kMKk0Q372gkHTKTj7K0MX1lvQkdUNyxYcxGZ5Dy5z4X0iDc3mpEJEkG2qoMwnFN95B9zMtPcT46I00zcTDs3Jc"
);
